import React, { useEffect, useRef, useState } from "react";
import styles from "./MarqueeText.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

interface MarqueeTextProps {
  text: string | React.ReactNode;
  width?: string;
  startPosition?: "left" | "middle" | "right";
  //   duration?: number;
  className?: string;
  fontSize?: string;
}

const MarqueeText: React.FC<MarqueeTextProps> = ({
  text,
  width = "100%",
  startPosition = "middle",
  //   duration = 15,
  className,
  fontSize = "",
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [contentWidth, setContentWidth] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    if (contentRef.current && containerRef.current) {
      setContentWidth(contentRef.current.offsetWidth);
      setContainerWidth(containerRef.current.offsetWidth);
    }
  }, [text]);

  const getStartPosition = () => {
    switch (startPosition) {
      case "left":
        return "0%";
      case "middle":
        return "50%";
      case "right":
        return "100%";
      default:
        return "50%";
    }
  };

  const getAnimationDuration = () => {
    // Calculate duration based on content width and container width
    const distance = contentWidth + containerWidth;
    const speed = 50; // pixels per second
    return `${distance / speed}s`;
  };

  return (
    <div
      ref={containerRef}
      className={`${styles.marqueeContainer} ${className || ""}`}
      style={{ width, fontSize }}
    >
      <div
        ref={contentRef}
        className={styles.marqueeContent}
        style={{
          paddingLeft: getStartPosition(),
          animationDuration: getAnimationDuration(),
        }}
      >
        {text}
      </div>
      <div
        className={styles.marqueeContent}
        style={{
          paddingLeft: getStartPosition(),
          animationDuration: getAnimationDuration(),
        }}
      >
        {text}
      </div>
    </div>
  );
};

export default wrapperHOC(MarqueeText, {
  componentName: "MarqueeText",
  showForChina: true,
});
